import { Checkbox, Modal, Table } from "antd";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { convertUTCDate } from "../../../../../utils/convertionFunc";
import rpmService from "../../../../../Services/rpmService";
import { fetchRpmFrequenciesList } from "../../../../../Redux/actions/rpmActions";

function FrequencyListTable({ data, currentPage, totalPages, setCurrentPage }) {
  const [actInactiveMod, setActInactiveMod] = useState(false);
  const [loader, setLoader] = useState(false);
  const [selectedFreq, setSelectedFreq] = useState(null);
  const dispatch = useDispatch();
  const loggedUserObj = localStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;

  const columns = [
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
      sorter: (a, b) => (a.code ? a.code.localeCompare(b.code) : ""),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => (a.name ? a.name.localeCompare(b.name) : ""),
    },
    {
      title: "Frequency",
      dataIndex: "description",
      key: "description",
      sorter: (a, b) =>
        a.description ? a.description.localeCompare(b.description) : "",
    },
    {
      title: "Active/Inactive",
      dataIndex: "isActive",
      key: "isActive",
      render: (_, record) => (
        <Checkbox className="checkbox-green" checked={record.status === 1} />
      ),
    },
  ];

  const handleFreqActInactive = async () => {
    setLoader(true);
    const payload = {
      ...selectedFreq,
      id: selectedFreq.id,
      modifiedBy: loggedUser?.user?.userId,
      modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      status: 0,
    };
    try {
      await rpmService.frequencyActiveInactive(payload);
      handleStatusChange(null, "close");
      setLoader(false);
      dispatch(fetchRpmFrequenciesList({ status: 1 }));
    } catch (e) {
      setLoader(false);
      console.error(e);
    }
  };

  const handleStatusChange = (device, action) => {
    if (action === "open") {
      setActInactiveMod(true);
      setSelectedFreq(device);
    } else if (action === "close") {
      setActInactiveMod(false);
      setSelectedFreq(null);
    }
  };

  return (
    <>
      <div>
        <div
          className={`min-w-full ${
            data ? "w-max" : "flex-1"
          } rounded-lg flex justify-center py-2`}
        >
          <table className={`w-full mx-2 overflow-scroll relative`}>
            <thead className="sticky top-0 bg-white z-10">
              <tr>
                <th>Code</th>
                <th>Name</th>
                <th>Frequency</th>
                <th>Active/Inactive</th>
              </tr>
              <tr className="bg-[#DEF3F2]">
                <td className="py-0.5" colSpan={12}></td>
              </tr>
            </thead>
            <tbody className="text-center">
              {data?.map((item, idx) => (
                <React.Fragment key={idx}>
                  <tr>
                    <td>{item.code}</td>
                    <td>{item.name}</td>
                    <td>{item.description}</td>
                    <td>
                      <Checkbox
                        className="checkbox-green"
                        checked={item.status === 1}
                        onClick={() => handleStatusChange(item, "open")}
                      />
                    </td>
                  </tr>
                  <tr className="bg-[#DEF3F2]">
                    <td className="py-0.5" colSpan={12}></td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>

        {/* Optional Pagination */}
        {/* <div className="absolute -bottom-32 right-8 flex justify-end my-2">
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={(page) => setCurrentPage(page)}
                        containerClassName="mb-4"
                        buttonClassName="border border-gray-300 md:px-3 px-2 rounded-full md:py-1 py-0.5 transition duration-300 ease-in-out focus:outline-none hover:bg-[#787878]"
                        activeButtonClassName="bg-brand-primaryColor rounded-full text-white"
                    />
                </div> */}
      </div>

      {/* Active/ Inactive confirmation modal */}
      <Modal
        open={actInactiveMod}
        onCancel={() => handleStatusChange(null, "close")}
        footer={[]}
        destroyOnClose
        title="Confirmation"
      >
        <div>
          <p>Are you sure you want to change the status</p>
          <div className="w-full flex justify-end items-center mt-3">
            <button
              onClick={() => handleStatusChange(null, "close")}
              className="mx-1 p-1 w-24 border rounded-md bg-white border"
            >
              Cancel
            </button>
            <button
              disabled={loader}
              onClick={handleFreqActInactive}
              className="mx-1 p-1 w-24 font-semibold bg- text-white rounded-md disabled:cursor-not-allowed disabled:opacity-50"
            >
              Ok
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default FrequencyListTable;
